import React from 'react';
import { Link } from 'react-router-dom';

export const Banner = ({ title, text, buttonText, buttonLink, backImage, sideImage }) => (
	<section className="main-banner">
		<div className="banner-inner clearfix">
			<svg className="svg-reset">
				<defs>
					<clipPath id="svgPath">
						<path
							d="M0 774.318C104.25 886.115 346.5 1118.56 538.5 1114.96C687.457 1112.16 1206.58 787.043 1610.46 515.747C1669.56 545.479 1743.47 534.963 1791.86 484.889C1824.59 451.023 1838.84 406.106 1834.81 362.621C1865.01 341.673 1893.52 321.752 1920 303.125V0H1457.55H1067.67H0V774.318Z" />
					</clipPath>
				</defs>
			</svg>


			<svg className="svg-reset" viewBox="0 0 2560 1356">
				<defs>
					<clipPath id="svgPathBig">
						<path
							d="M0,901.97758 C139,1050.9745 462,1360.74256 718,1355.94491 C916.61,1352.22673 1608.77,918.93926 2147.28,557.388601 C2226.07,597.012165 2324.63,582.998039 2389.15,516.265771 C2432.79,471.133909 2451.78,411.27327 2446.42,353.321696 C2486.68,325.405388 2524.7,298.856411 2560,274.031587 L2560,0 L0,0 L0,901.97758 Z" />
					</clipPath>
				</defs>
			</svg>


			<div className="auto-container">
				<div className="content-box">
					<h2>{title}</h2>
					<div className="text">{text}</div>
					<div className="link-box">
						<Link to={buttonLink} className="theme-btn btn-style-one">{buttonText}</Link>
					</div>
				</div>
			</div>
		</div>

		<div className="big-image">
			<figure className="image wow fadeInRight">
				<img src={sideImage} alt={title} />
			</figure>
		</div>
	</section>
);



// WEBPACK FOOTER //
// ./src/components/ui/Banner/Banner.js